import { memberConfigurationReqPayload } from "../modules/help/contact.model";
import { IEnrolmentReqPayload } from "../modules/home/home.model";
import { LogParameter } from "../modules/profile/Account.model";
import SendRequest from "../services/sendRequest.service";
import { logAPIStatus } from "./claim";

export const enrolmentsApi = async( payload: IEnrolmentReqPayload) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/member/enrolment`;
    const response = await SendRequest.instance.post( url, payload );
    return response;
  };
  
  export const MemberdomiBalApi =async ( payload: any) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/member/domibalance`;
    const response = await SendRequest.instance.post( url, payload );
    const logsData : LogParameter = {
      isDataLoaded : response.isSuccess,
      actionPage : 'policy' ,
      requestBody:JSON.stringify(payload),
      responseBody:JSON.stringify(response),
      entityName: url
    }
    logAPIStatus(logsData);
    return response;
  };

  export const memberConfigApi =async ( payload: memberConfigurationReqPayload) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/member/configuration`;
    const response = await SendRequest.instance.post( url, payload );
    const logsData : LogParameter = {
      isDataLoaded : response.isSuccess,
      actionPage : 'Contact' ,
      requestBody:JSON.stringify(payload),
      responseBody:JSON.stringify(response),
      entityName: url
    }
    logAPIStatus(logsData);
    return response;
  };
